import { render, staticRenderFns } from "./StartseiteAnmeldungen.vue?vue&type=template&id=dd73756e&"
import script from "./StartseiteAnmeldungen.vue?vue&type=script&lang=js&"
export * from "./StartseiteAnmeldungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports